(ns branding.views
  (:require
    [very.re-frame.core :as rf]
    [css.core :refer [defstyled get-theme]]))

(defstyled logo-wrapper-s :div
  {:width "150px"
   :height "75px"
   :display "flex"
   :position "relative"
   :margin (with-meta #(or % "0") :margin)
   :align-items "center"
   :justify-content (with-meta #(or % "flex-start") :justify-content)})

(defstyled logo-s :img
  {:width "auto"
   :max-width "100%"
   :height "auto"
   :max-height "100%"})

(defstyled footer-grid-s :div
  {:display "grid"
   :grid-column "content"
   :grid-template-columns "[left-gutter-start] minmax(1rem, 1fr) [left-gutter-end content-start] minmax(min-content, 82rem) [content-end right-gutter-start] minmax(1rem, 1fr) [right-gutter-end]"
   :justify-content "center"
   :align-items "center"})

(defstyled footer-s :div
  {:grid-column "content"
   :color "white"
   :padding "2rem 0"
   :font-size "12px"
   :line-height "18px"})

(defn logo [{:keys [margin justify-content]}]
  (let [brand (rf/subscribe [:brand])]
    (fn []
      [logo-wrapper-s {:margin margin :justify-content justify-content}
       [logo-s {:src (or (:logo @brand) "")
                :alt (or (:name @brand) "")}]])))

(defn footer []
  (let [brand (rf/subscribe [:brand])]
    (fn []
      [footer-grid-s
       [footer-s {:dangerouslySetInnerHTML {:__html (:disclosure @brand)}}]])))
